// NATIVE 
import React, { useEffect, useState } from 'react'


// INSTALLED 
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumbs, Button,  Grid, Typography } from '@mui/material';


import { TableCustomer } from './components/TableCustomer';
import { MiniCardGlobal } from 'components/MiniCardGlobal';
import { People, Add as AddIcon } from '@mui/icons-material';
import { theme } from 'commons/theme';
import { getCustomersStore } from 'store/customer';
import { SnackAlert } from 'components/SnackAlert';
import { hasPemissions } from 'commons/utils';
import { PageLayout } from 'components/generics/PageLayout';
import { BannerInfoCustomer } from './components/BannerInfoCustomer';

export const Customer = () => {


  const dispatch = useDispatch();

   // REDUX
   const  {  customers_list }:any  = useSelector( (state:any) => state.customer );


  const [activos,   setActivos] = useState(0);
  const [vencidos,  setVencidos] = useState(0);
  const [inactivos, setInactivos] = useState(0);

  const [alert_snack, setAlertSnack] = useState(false);

  const [message_alert_snack, setMessageAlertSnack] = React.useState('');
  const [type_alert_snack, setTypeAlertSnack] = React.useState('success');
  
  const [canCreate, setCanCreate] = useState(false);

  useEffect(() => {
    canCheckCanCreate();
  }, []);

  const canCheckCanCreate = async () => {
    const havePermissions = await hasPemissions('modulo.manager', 'modulo.cliente', 'create');
    setCanCreate(havePermissions);
  }

  useEffect(() => {
    
    setActivos(customers_list?.activos || 0);
    setVencidos(customers_list?.vencidos || 0);
    setInactivos(customers_list?.inactivos || 0);

  }, [customers_list]);
  





  return (


    <>
       <PageLayout
           title="Listado de Clientes"
           mainModule="Manager"
           icon="People"
           infoAlert="Administración general de clientes y sus permisos."
           actionButtons={
               <>
                   {canCreate && (
                       <Button 
                           variant="contained" 
                           color="primary" 
                           startIcon={<AddIcon />} 
                           component={Link}
                           to={'/manager/crear-cliente'}
                           sx={{
                               borderRadius: 2,
                               px: 3,
                               py: 1,
                               fontWeight: 600,
                               textTransform: 'none',
                               boxShadow: '0px 4px 8px -4px rgba(105, 108, 255, 0.42)'
                           }}
                       >
                           Crear Cliente
                       </Button>
                   )}
               </>
           }
       >
           <SnackAlert open={alert_snack} onclick={setAlertSnack} text={message_alert_snack} severity={type_alert_snack as any}/>
           
          

           <Grid container sx={{ marginBottom: 2 }}>
             <Grid size={{ xs: 4 }} sx={{ padding: 1 }}>
               <MiniCardGlobal
                 title="Activos"
                 count={activos}
                 icon={<People fontSize="large" />}
                 colorBgIcon={theme.palette.success.light}
                 totalText='Total Clientes'
                 colorTitle={'#5DCC0A'}
                 bgTitle={'#E4F6D6'}
               />
             </Grid>

             <Grid size={{ xs: 4 }} sx={{ padding: 1 }}>
               <MiniCardGlobal
                 title="Vencidos"
                 count={vencidos}
                 icon={<People fontSize="large"  />}
                 colorBgIcon={theme.palette.warning.light}
                 totalText='Total Clientes'
                 colorTitle={'#FFB911'}
                 bgTitle={'#FFF3D6'}
               />
             </Grid>

             <Grid size={{ xs: 4 }} sx={{ padding: 1 }}>
               <MiniCardGlobal
                 title="Inactivos"
                 count={inactivos}
                 icon={<People fontSize="large"  />}
                 colorBgIcon={theme.palette.error.light}
                 totalText='Total Clientes'
                 colorTitle={'#FF4C51'}
                 bgTitle={'#FFE2E3'}
               />
             </Grid>
           </Grid>
        
            <TableCustomer />
            <BannerInfoCustomer />
       </PageLayout>
    </>
    
  )
}
